import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import infoIcon from '../images/package-info/info.svg';
import {dwhShowCurrentPackageDisplay} from '../reports/dwhReports';
const CurrentPackagePopupContent = (props) => {
  useEffect(() => {
    //Ga old
    gaEvent(
      gaParams.CHANGE_PRICE_PLAN_POPUP_CURRENT_PLAN_DATA_IS_SHOWN.category,
      gaParams.CHANGE_PRICE_PLAN_POPUP_CURRENT_PLAN_DATA_IS_SHOWN.eventType,
      gaParams.CHANGE_PRICE_PLAN_POPUP_CURRENT_PLAN_DATA_IS_SHOWN.eventParams
    );
  }, []);

  return (
    <Container className={` ${isMobile ? 'isMobile pr-0 pl-0' : ''} text-center current-package-popup`}>
      <Col className='mb-3'>
        <Image src={infoIcon} />
      </Col>
      <Row>
        <p className='bold main-text d-block w-100 mb-4'>מה בחבילה?</p>
      </Row>
      <Row>
        <Col xs={12} md={10} className='m-auto p-0'>
          <p className='w-100 current-package-data text-right'>{props.package}</p>
        </Col>
      </Row>
    </Container>
  );
};

export default CurrentPackagePopupContent;
